var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faExclamationCircle, faExclamationTriangle, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MessageBox } from "syf-component-library/ui/patterns";
import Inset from "syf-component-library/ui/spacing/Inset";
import { Small } from "syf-component-library/ui/typography";
import Body from "syf-component-library/ui/typography/Body";
import { generateUUID } from "syf-js-utilities";
import { useEditProfileContext } from "../../../context/editProfileContext";
import getTranslation from "../../../strings/getTranslations";
var CustomMessageBox = function (_a) {
    var message = _a.message, icon = _a.icon, type = _a.type, size = _a.size;
    var t = getTranslation().t;
    var fieldErrorStrings = useEditProfileContext().fieldErrorStrings;
    var userDeclinedMessage = t("forms.errors.page.userDeclined");
    var messageType = type || "error";
    var iconProp = icon || faExclamationCircle;
    var insetSize = size || "large";
    if (message === userDeclinedMessage) {
        messageType = "warning";
        iconProp = faExclamationTriangle;
        insetSize = "small";
    }
    if (message !== "") {
        return (_jsx(Inset, __assign({ top: insetSize, bottom: "medium", left: "medium", right: "medium", hideOnlyOnBreakpoints: [] }, { children: _jsxs(MessageBox, __assign({ type: messageType, role: "alertdialog", icon: _jsx(FontAwesomeIcon, { icon: iconProp, size: "lg" }), closeButtonAriaLabel: "Dismiss Message" }, { children: [_jsx(Body, { children: message }), fieldErrorStrings === null || fieldErrorStrings === void 0 ? void 0 : fieldErrorStrings.map(function (errorMessage) {
                        return (_jsxs(Small, { children: [" ", "- ", t(errorMessage)] }, generateUUID()));
                    })] })) })));
    }
    return null;
};
export default CustomMessageBox;
